/**
 * Read a Sentry sample rate from the environment, so a flood can be shed by
 * editing Doppler rather than by changing code.
 *
 * Its own module because the browser entry (`instrumentation-client.ts`) needs
 * it and must not pull in `lib/telemetry/sentry.ts`, which is server-only.
 *
 * A value that is not a number falls back rather than throwing: a typo in a
 * Doppler secret must not take the runtime down, and a wrong rate is visible in
 * the event volume within minutes. An empty value is unset, not zero:
 * `Number('')` is `0`, so a key left blank in Doppler would otherwise switch
 * the signal off. A number outside [0, 1] is clamped to it.
 */
export function readSampleRate(
  raw: string | undefined,
  fallback: number
): number {
  const parsed = raw?.trim() ? Number(raw) : fallback;
  return Number.isFinite(parsed) ? Math.min(1, Math.max(0, parsed)) : fallback;
}
